import type { MethodType } from '@piccolohealth/pbs-common';
import type { SelectOption } from '@piccolohealth/ui';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { BadgeItem } from '../../../../components/generic/BadgeItem';

interface Props {
  option: SelectOption<MethodType>;
  description?: string;
}

export const MethodOption = (props: Props) => {
  const { option, description } = props;

  return (
    <ChakraV3.HStack w='full'>
      <BadgeItem label={option.label} color={option.color} />
      <ChakraV3.Spacer />
      {description && (
        <ChakraV3.Text color='gray.500' fontSize='xs'>
          {description}
        </ChakraV3.Text>
      )}
    </ChakraV3.HStack>
  );
};
